/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Project_CompleteInputs */



/**
* | output |
* | --- |
* | "Project import complete..." |
*
* @param {Work_Order_Import_Status_Project_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_project_complete = /** @type {((inputs?: Work_Order_Import_Status_Project_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Project_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet terminée...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektimport abgeschlossen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto completata...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт проекта завершен...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación del proyecto completada...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目导入完成……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポートが完了しました...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट का आयात पूरा हो गया...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação do projeto concluída...")
	return /** @type {LocalizedString} */ ("Project import complete...")
});